import { useQuery } from "@tanstack/react-query";
import type { z } from "zod";
import { patientApi } from "./apiClient";
import { patientBaseSchema } from "@medoma/models/patients";
import { siteSchema } from "@medoma/models/sites";

// Care is read by the patient, so it accepts only the fields it shows them: who they
// are, and which site cares for them. The rest of the patient record — clinical,
// administrative and staff-facing alike — is dropped at this boundary. Picked from
// the shared base so the shapes stay in step, and `name` stays required so a deleted
// patient, who has none, still fails to parse.
const patientSchema = patientBaseSchema
  .pick({ id: true, name: true })
  .extend({ site: siteSchema.pick({ id: true }) });
export type IPatient = z.infer<typeof patientSchema>;

const patientKeys = {
  detail: ["patient"] as const,
};

const fetchPatient = async () => {
  return await patientApi.get("patient").json(patientSchema);
};

export const usePatient = () => {
  return useQuery({
    queryKey: patientKeys.detail,
    queryFn: fetchPatient,
    staleTime: 1000 * 60 * 10,
  });
};
